import { SafeError, SafePromise } from '@benzinga/safe-await';
import { Subscribable } from '@benzinga/subscribable';
import { MortgageRateTrendChartDataPoint } from './entities';
import { MortgageRatesRestful } from './restful';
import { Session } from '@benzinga/session';

interface ErrorEvent {
  error?: SafeError;
  errorType: 'get_mortgage_rates_error';
  type: 'error';
}

interface GetMortgageEvent {
  type: 'get_mortgage_rates';
}

export type MortgageRatesRequestEvent = GetMortgageEvent | ErrorEvent;

export class MortgageRatesRequest extends Subscribable<MortgageRatesRequestEvent> {
  private restful: MortgageRatesRestful;

  constructor(session: Session) {
    super();
    this.restful = new MortgageRatesRestful(session);
  }

  public getMortgageRateTrends = async (): SafePromise<MortgageRateTrendChartDataPoint[] | undefined> => {
    this.dispatch({
      type: 'get_mortgage_rates',
    });
    const res = await this.restful.getMortgageRateTrends();
    if (res.err) {
      this.dispatch({
        error: res.err,
        errorType: 'get_mortgage_rates_error',
        type: 'error',
      });
    }
    if (res.ok?.status === 200) {
      return { ok: res.ok?.data };
    }
    return { ok: [] };
  };
}
